<mat-nav-list>
  <a mat-list-item routerLink="/charts" routerLinkActive="active">
    <img alt="charts icon" src="../../../../assets/img/chart-icon.png" style="width: 50px; transform: translateX(-10px)">
    <p class="charts-item">Charts</p>
  </a>
  <a mat-list-item routerLink="/therapeutics" routerLinkActive="active">
    <img alt="therapeutics icon" src="../../../../assets/img/pill.png" style="width: 30px;">
    <p class="item-text">Therapeutics</p>
  </a>
  <a mat-list-item routerLink="/vaccines" routerLinkActive="active">
    <img alt="vaccines icon" src="../../../../assets/img/vaccine-icon.png" style="width: 30px;">
    <p class="item-text">Vaccines</p>
  </a>


</mat-nav-list>
